
    <h2 mat-dialog-title>Remove?</h2>
    <div>
      This will remove this system from this design.
    </div>
    <div style="position: relative;margin-top: 10px;top: 20px;left: 42px;width: 70%;">
      <button mat-button style="background: red;color: white;" (click)="dref.close(1)" mat-dialog-close='1' >Remove</button>
      <button mat-button (click)="dref.close(2)" mat-dialog-close='2' style="margin-left: 40px;background: #ffffffaf;">Cancel</button>
    </div>
  